import { JSX } from "react";
import SiaBlackLogo from "@/assets/sia-ai-black.png";

const AuthLayout = (props: { children: JSX.Element }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-12">
      <img src={SiaBlackLogo} alt="sia-ai-logo" className="h-12 max-w-sm"></img>
      {props.children}
    </div>
  );
};

export default AuthLayout;
